import React, { DetailedHTMLProps } from 'react'
import styles from './BoxUi.module.scss'
import cn from 'classnames'

export interface IPropsWithChild {
  children: JSX.Element | JSX.Element[]
}

export type CustomDivProps = IPropsWithChild &
  DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

const BoxUi: React.FC<CustomDivProps> = ({ children, className, ...props }) => {
  return (
    <div className={cn(styles.container, className)} {...props}>
      {children}
    </div>
  )
}

export default BoxUi
